import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Check } from "lucide-react";

export default function Automated() {
  const { ref, isVisible } = useScrollReveal();

  const features = [
    {
      title: "Managed publishing",
      description: "Your videos are prepared and published to MSN",
    },
    {
      title: "Zero learning curve",
      description: "No new skills or tools to master",
    },
    {
      title: "Full support",
      description: "Our team handles all technical stuff",
    },
  ];

  return (
    <div
      ref={ref}
      className={`${
        isVisible ? "" : ""
      } bg-white py-20 lg:py-32 px-4 xxs:px-8 xs:px-10 sm:px-10 md:px-10 lg:px-12 xl:px-12 4xl:px-16`}
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-[150px]">
          {/* Left Section - Image */}
          <div className="lg:w-[389px] flex-shrink-0 h-[685px] order-2 lg:order-1">
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/boost-content.png"
              alt="Boost Content"
              className="w-full h-full object-contain"
            />
          </div>

          {/* Right Section */}
          <div className="flex-1 flex flex-col gap-[27px] max-w-[728px] order-1 lg:order-2">
            {/* Numbered Badge */}
            <div className="bg-gradient-to-b from-[#3b82f6] to-[#2563eb] rounded-[100px] w-[77px] h-[50px] flex items-center justify-center -mt-4 xxs:-mt-32 xs:-mt-16 sm:-mt-16 md:-mt-0 lg:mt-0">
              <p className="text-[32px] font-semibold text-white">04</p>
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl xxs:text-[55px] lg:text-[80px] 4xl:text-[80px] font-normal text-black leading-[106px] xxs:leading-normal xs:leading-normal sm:leading-normal md:leading-normal lg:leading-normal enfinity-header-font" style={{ lineHeight: "1.2" }}>
              <span>We handle </span>
              <span className="text-[#3b82f6]">everything end to end</span>
            </h1>

            {/* Description */}
            <p className="text-xl xxs:text-[1rem] lg:text-[24px] font-normal text-black leading-[34px] enfinity-subtext-font">
            Keep creating videos as usual, we take care of posting them to MSN for you. No extra work or new tools required.
            </p>

            {/* Features List */}
            <div className="flex flex-col gap-[30px] max-w-[680px]">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-[15px] items-start">
                  {/* Check Icon */}
                  <div className="bg-[#3b82f6] rounded-[10px] w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <Check className="w-5 h-5 text-white" strokeWidth={2} />
                  </div>

                  {/* Feature Content */}
                  <div className="flex flex-col gap-[10px]">
                    <p className="text-[24px] font-medium text-black leading-[35px] enfinity-header-font">
                      {feature.title}
                    </p>
                    <p className="text-[18px] xxs:text-[1rem] lg:text-lg 4xl:text-[19px] font-normal text-black leading-normal enfinity-subtext-font">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

